// Layout
const dashboardLayout = () => import('@/layouts/DashboardLayout/dashboardLayout.vue')

// Views
const TermsCondition = () => import('./views/TermsCondition.vue')
const PrivacyPolicy = () => import('./views/PrivacyPolicy.vue')

// Website routes (Terms & Conditions + Privacy Policy)
export default [
  {
    path: '/website',
    component: dashboardLayout,
    children: [
      {
        path: 'terms-and-conditions',
        name: 'termsCondition',
        meta: {
          name: 'termsCondition',
          parentName: 'website',
          userType: 'both',
          permission: '',
          role: ''
        },
        component: TermsCondition
      },
      {
        path: 'privacy-policy',
        name: 'privacyPolicy',
        meta: {
          name: 'privacyPolicy',
          parentName: 'website',
          userType: 'both',
          permission: '',
          role: ''
        },
        component: PrivacyPolicy
      }
    ]
  }
]
